import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        width: "100%",
        padding: "20px",
        textAlign: "center",
        borderTop: "1px solid #ddd",
        // marginTop: "30px",
      }}
    >
      <Box m={2} />
      <Typography variant="body2" color="textSecondary">
        © {new Date().getFullYear()} dipechain.xyz, All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
